var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 243.500 1.350 C 231.601 5.290, 221.221 13.685, 216.342 23.312 C 203.206 49.232, 56.565 456.412, 56.534 467.052 C 56.416 507.171, 104.538 527.421, 132.764 499.130 C 139.928 491.949, 141.610 488.113, 162.088 432.268 C 172.528 403.796, 182.218 377.462, 183.622 373.750 C 186.175 367, 186.175 367, 256 367 C 325.825 367, 325.825 367, 328.378 373.750 C 329.782 377.462, 339.430 403.675, 349.818 432 C 370.982 489.708, 371.899 491.804, 379.170 499.075 C 407.523 527.428, 455.578 507.259, 455.469 467.052 C 455.440 456.413, 308.801 49.249, 295.657 23.310 C 286.875 5.979, 261.625 -4.652, 243.500 1.350 M 237.745 226.350 C 227.985 252.942, 220 274.992, 220 275.350 C 220 275.707, 236.200 276, 256 276 C 275.800 276, 292 275.707, 292 275.350 C 292 274.024, 256.490 178, 256 178 C 255.720 178, 247.505 199.757, 237.745 226.350",
    stroke: "none",
    fill: "#a3a3a3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoA);
export default __webpack_public_path__ + "static/media/ico-a.12bde4587aecc4b041a55e2baa7679be.svg";
export { ForwardRef as ReactComponent };